{
  "title": "rally ops room",
  "guide": "Enter the join code, and the time to open your rally appears as a countdown.",
  "ctGuide": "Enter the room admin code, and the ops setup screen opens.",
  "gameIdGuide": "Enter your game ID as registered in the CT's roster list.",
  "codeLabel": "Join code",
  "codePlaceholder": "e.g. 7K2M9PQR3T",
  "codeSubmit": "Next",
  "confirmTitle": "This room's CT. Is this the right room?",
  "confirmBack": "Re-enter code",
  "confirmNext": "Yes, correct",
  "gameIdLabel": "Game ID",
  "gameIdPlaceholder": "e.g. 131952426",
  "gameIdSubmit": "Join",
  "joinedTitle": "Joined",
  "joinedBody": "Tap “Go to ops view” below to see the rally list of this ops. Pick your own rally there, and the open countdown and the signal start.",
  "joinedBodyDefense": "The CT is looking at defense right now, so “Go to ops view” opens the defense view first. To start your open countdown and signal, switch to the attack view at the bottom and pick your rally.",
  "presenceTitle": "In the room",
  "presenceEmpty": "No one has joined yet",
  "presenceStale": "Disconnected. The list below is not current",
  "sessionGone": "This connection has ended. Enter the join code again.",
  "sessionGoneRemoved": "The CT removed you from the roster list. Ask the CT to add you again.",
  "sessionGoneKicked": "The CT disconnected you. Enter the join code again to rejoin.",
  "connections": "Connections",
  "leave": "Leave",
  "ctBranch": "Are you the CT? Use the room admin code",
  "ctCodeLabel": "Room admin code",
  "ctCodePlaceholder": "e.g. 7K2M9PQR3TVWXY01",
  "ctSubmit": "Go to ops setup",
  "ctBack": "Back to join code",
  "goView": "Go to ops view"
}
